/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ROUTES } from "../constants/constants";
import LoadingIndicator from "./LoadingIndicator";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isClientLoading, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && !isClientLoading && !isAuthenticated) {
      navigate(ROUTES.HOME, { replace: true });
    }
  }, [isAuthenticated, isClientLoading, isInitialized, navigate]);

  if (!isInitialized || isClientLoading) {
    return <LoadingIndicator page />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
